



























































































import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { VbSnackbarService } from 'bag-of-holding-library';
import ModalComponent from '@/shared/modal/modal.component.vue';
import ModalOptions from '@/shared/modal/modal-options.entity';
import Copy from '@/shared/copy.component.vue';
import AuthorityService from '@/domain/security/authority.service';
import MyAuthority from '@/domain/security/my-authority.entity';
import Permission from '@/domain/security/permission.entity';

@Component({
  components: {
    ModalComponent,
    Copy,
  },
})
export default class MyAccessModal extends Vue {
  @Prop() value!: boolean;

  myAuthorities: MyAuthority[] = [];

  loading = false;

  search = '';

  openPanels: number[] = [];

  async created() {
    this.loading = true;
    await AuthorityService.myAuthorityProfiles()
      .then((response) => {
        this.myAuthorities = response.map(item => new MyAuthority(item));
      })
      .catch(VbSnackbarService.handleHttpError)
      .finally(() => this.loading = false);
  }

  grantedPermissions(authority: MyAuthority): Permission[] {
    return authority.screens
      .flatMap(screen => screen.permissions)
      .filter(permission => permission.grantedAccess);
  }

  filteredPermissions(authority: MyAuthority): Permission[] {
    const term = (this.search || '').trim().toLowerCase();
    if (!term) return this.grantedPermissions(authority);
    return this.grantedPermissions(authority)
      .filter(permission => permission.description.toLowerCase().includes(term)
        || permission.name.toLowerCase().includes(term));
  }

  get visibleAuthorities(): MyAuthority[] {
    if (!this.search) return this.myAuthorities;
    return this.myAuthorities.filter(authority => this.filteredPermissions(authority).length > 0);
  }

  @Watch('search')
  onSearchChange() {
    this.openPanels = this.search
      ? this.visibleAuthorities.map((_, i) => i)
      : [];
  }

  get copyText(): string {
    const lines = [
      `Nome: ${this.name}`,
      `E-mail: ${this.email}`,
      '',
      'Grupos e permissões:',
    ];
    if (this.myAuthorities.length === 0) {
      lines.push('- Colaborador Básico (sem grupos adicionais)');
      return lines.join('\n');
    }
    this.myAuthorities.forEach((authority) => {
      lines.push(`- ${authority.description || authority.name}`);
      const permissions = this.grantedPermissions(authority);
      if (permissions.length === 0) {
        lines.push('  (nenhuma permissão liberada)');
      } else {
        permissions.forEach(permission => lines.push(`  - ${permission.description}`));
      }
    });
    return lines.join('\n');
  }

  get name() {
    return this.$store.state.name;
  }

  get email() {
    return this.$store.state.email;
  }

  get optionsHandled(): ModalOptions {
    return {
      title: 'Meus Acessos',
      titleSize: '20px',
      showOk: false,
      showCancel: true,
      labelCancel: 'Fechar',
      width: 500,
    };
  }

  close() {
    this.$emit('close');
  }
}
